import type { ReactNode } from 'react';
import { AppShell, Badge, Box, Button, Container, Group, Text } from '@mantine/core';
import { Logo } from '@fololabs/design/components';
import { DEMO_MODE } from '../config';

interface Props {
  children: ReactNode;
  /** Signed-in email shown in the header. Omit on login/error chrome. */
  email?: string;
  onSignOut?: () => void;
}

/** Shared launcher chrome — Aquifer header + main container. Every
 *  signed-in state (tiles, loading skeleton, no-access, error) renders
 *  inside this so the brand frame is constant. */
export function LauncherShell({ children, email, onSignOut }: Props) {
  return (
    <AppShell
      header={{ height: DEMO_MODE ? 88 : 60 }}
      style={{ backgroundColor: 'var(--mantine-color-mist-2)' }}
    >
      <AppShell.Header
        style={{
          backgroundColor: 'var(--mantine-color-aquifer-7)',
          borderBottom: 'none',
        }}
      >
        {DEMO_MODE && (
          <Box
            style={{
              backgroundColor: 'var(--mantine-color-spring-6)',
              color: 'var(--mantine-color-aquifer-9)',
              textAlign: 'center',
              fontWeight: 600,
              fontSize: 12,
              letterSpacing: '0.08em',
              padding: '4px 0',
            }}
          >
            DEMO ENVIRONMENT · MOCK SIGN-IN · NOT PRODUCTION DATA
          </Box>
        )}
        <Container size="lg" h={60}>
          <Group h="100%" justify="space-between">
            <Group gap="sm" align="center">
              <Box style={{ color: 'white' }}>
                <Logo size={28} />
              </Box>
              {DEMO_MODE && (
                <Badge color="spring" variant="filled" size="sm" radius="sm">
                  DEMO
                </Badge>
              )}
            </Group>
            {email && (
              <Group gap="sm">
                <Text size="sm" c="white" opacity={0.85}>
                  {email}
                </Text>
                {onSignOut && (
                  <Button
                    variant="subtle"
                    color="white"
                    size="xs"
                    onClick={onSignOut}
                  >
                    Sign out
                  </Button>
                )}
              </Group>
            )}
          </Group>
        </Container>
      </AppShell.Header>

      <AppShell.Main>
        <Container size="lg" py="xl">
          {children}
        </Container>
      </AppShell.Main>
    </AppShell>
  );
}
